<template>
  <v-row>
    <v-col cols="12" xs="12" md="10">
      <v-text-field
        name="inventorySearch"
        outlined
        dense
        label="Search"
        v-model="search"
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12" md="10">
      <v-btn text :loader="loader"></v-btn>
      <!-- start of table -->
      <v-data-table
        loading-text="Loading Data......"
        :items-per-page="1000"
        :headers="headers"
        :items="inventory"
        :search="search"
        :mobile-breakpoint="0"
      >
        <template v-slot:item.product.Name="{ item }">
          <v-btn color="primary" text :to="`/quick-audit/${item.product.id}`">{{
            item.product.Name
          }}</v-btn>
        </template>

        <template v-slot:item.verified="{ item }">
          <v-btn v-if="loader" text :loading="loader">Loading-----</v-btn>
          <div v-else>
            <span v-if="item.verified == 'Y'" style="color: green; font-weight: bold">Verified</span>
          <v-btn v-else @click="openVerifiedModal(item)" color="red" text>Not Verified <v-icon right>mdi-exclamation</v-icon></v-btn>
          </div>
         
        </template>
      </v-data-table>
      <!-- end -->
    </v-col>





    <!-- Ctreate shop dialog -->
    <v-dialog v-model="verifiedDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Verify Stock</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="verifiedDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span style="font-weight: bold">Are you sure you want to  mark the following item as verified? </span>
              </v-col>

              <v-col cols="6">
                <span style="font-weight: bold">{{ selectedItem.product && selectedItem.product.Name }}</span>
              </v-col>

              <v-col cols="6">
                <span style="font-weight: bold; color: red">{{ selectedItem.AvailableQty }} {{ selectedItem.baseUom }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="verifyStock" :loading="loader">
                  <v-icon left>mdi-check</v-icon> Yes, Stock Verified
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of shop modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-row>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      search: null,
      pageItems: 500,
      loader: false,
      selectedItem: {},
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      verifiedDialog: false,
      headers: [
        { text: "Product Name", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" },
        { text: "Unit", value: "baseUom" },
        { text: "Verified", value: "verified" },
      ],
      inventory: [],
    };
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDamageModal(item) {
      this.damagedItem = Object.assign({}, item);
      this.damageDialog = true;
    },
    openVerifiedModal(item) {
      this.selectedItem = Object.assign({}, item);
      this.verifiedDialog = true;
    },
    inventoryInit() {
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", `/all-audit-stock`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.inventory = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  verifyStock() {
      const data = this.selectedItem;
      const url = `/verify-stock/${data.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
           self.inventoryInit();
           self.$refs.snackbar.show("done", "green");
           self.verifiedDialog = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const data = this.editItem;
      const url = `/inventory/${data.id}`;
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            location.reload();
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.inventoryInit(), this.getStores(), this.getUsers()]);
  },
};
</script>

<style lang="scss" scoped>
</style>